import React from 'react'
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from './api/api';


const UserMenu = () => {
  const navigate = useNavigate();
  
  const handleLogout = async () => {
    try {
      localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        navigate('/login')
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  const handleChangePassword = async () => {
    navigate('/change-password')
  }
    
  
  const handleLogin = async () => {
    navigate('/login')
  }

  return (
    <ul className="settings-submenu">
      <div id="div-setting-area">
        {isAuthenticated() ? 
          <>
            <li className="li-settings" onClick={handleChangePassword} >Change Password</li>
            <li className="li-settings" onClick={handleLogout}>Logout</li>
          </>
        :
          <>
            <li className="li-settings" onClick={handleLogin} >Login</li>
          </>
        }
        
      </div>
    </ul>
  )
}

export default UserMenu